import { useCallback, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import {
  XERO_STATUS_QUERY_KEY,
  getXeroStatus,
  type XeroConnection,
} from "@/services/xeroApi";


export function useXeroOrgName() {
  const { data } = useQuery({
    queryKey: XERO_STATUS_QUERY_KEY,
    queryFn: getXeroStatus,
  });

  const byId = useMemo(() => {
    const map = new Map<string, XeroConnection>();
    for (const connection of data?.connections ?? []) {
      map.set(connection.tenant_id, connection);
    }
    return map;
  }, [data?.connections]);

  return useCallback(
    (tenantId: string, fallbackName?: string | null): string => {
      const connection = byId.get(tenantId);
      const resolved =
        connection?.entity?.trim() ||
        connection?.tenant_name?.trim() ||
        fallbackName?.trim();
      if (resolved) return resolved;

      return `Unknown (${tenantId.slice(0, 8)}…)`;
    },
    [byId],
  );
}

export function useXeroOrgSubtitle() {
  const { data } = useQuery({
    queryKey: XERO_STATUS_QUERY_KEY,
    queryFn: getXeroStatus,
  });

  const byId = useMemo(() => {
    const map = new Map<string, XeroConnection>();
    for (const connection of data?.connections ?? []) {
      map.set(connection.tenant_id, connection);
    }
    return map;
  }, [data?.connections]);

  return useCallback(
    (tenantId: string): string | null => {
      const connection = byId.get(tenantId);
      const entity = connection?.entity?.trim();
      const name = connection?.tenant_name?.trim();
      return entity && name && entity !== name ? name : null;
    },
    [byId],
  );
}
